import { WindowWithLocalize } from 'common/types.typescript';
import { Settings } from 'luxon';

const windowWithLocalize = window as WindowWithLocalize;

const setLuxonLocale = (language: string) => {
  Settings.defaultLocale = language;
};

const listenForLocalize = () => {
  const localizeEnabled =
    windowWithLocalize.initializationData?.companyFeatures.localize_js_widget;

  if (!localizeEnabled) return;

  setTimeout(() => {
    if (windowWithLocalize.Localize) {
      const language = windowWithLocalize.Localize.getLanguage();
      setLuxonLocale(language);

      windowWithLocalize.Localize.on('setLanguage', data => {
        setLuxonLocale(data.to);
      });
    } else {
      listenForLocalize();
    }
  }, 1000);
};

export default listenForLocalize;
